<template>
  <div id="app">
    <router-view></router-view>     
  </div>
</template>
<script>
  export default {
    name: 'app'
  }
</script>

<style>
  html,
  body {
    overflow: auto;
    padding: 0;
    font-family: Arial, Helvetica, sans-serif;
    margin: 0;
    color:#eee;
    background: #28363b;
  }

  * {
    outline: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  #app {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  section {
    display: block;
  }

  button {
    padding: 15px 35px;
    cursor: pointer;
    background: inherit;
    border: inherit;
    color: inherit;
    border-radius: 25px;
    font-size: 18px;
    margin: 10px;
  }

  .hero,
  .features,
  .feedback,
  .preview,
  .conclusion {
    position: relative;
  }

  .feedback {
    height: 300px;
    text-align: center;
    color: #eee;
    font-size: 170%;
    line-height: 2;
  }

  .preview {
    text-align: center;
    background-color: #eee;
  }

  .preview img {
    height: 300px;
    margin: 10px;
  }

  .wrapper {
    width: 1000px;
    margin: 0 auto;
  }

  .hero {
    padding: 0 40px;
  }

  .hero-wrapper {
    height: 100vh;
    min-height: 600px;
    padding: 40px 0;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .hero-title,
  .pre-title,
  .fea-title {
    font-weight: 100;
    font-size: 40px;
    line-height: 1.5;
    left: 0;
  }

  .pre-title,
  .fea-title {
    color: #333;
  }

  .hero-title::after {
    content: "";
    display: block;
    line-height: 1em;
    border-bottom: 4px solid #27ae60;
    width: 40px;
  }

  .hero-content {
    max-width: 450px;
    font-size: 18px;
    line-height: 2;
    color: #eee;
  }

  .hero-text {
    height: 75px;
  }

  .primary {
    background: #27ae60;
  }

  .secondary {
    border: 1px solid #27ae60;
  }

  .prev-img {
    transform: scale(1.2);
  }

  .active::after {
    content: '';
    display: block;
    line-height: 1em;
    border-bottom: 2px solid #27AE60;
    width: 20px;
  }
.auth {
 display: flex;
 align-items: center;
 justify-content: center;
 color: #eee;
}
    .auth {
        display: flex;
        flex-direction:column;
        height:100%;
        align-items: center;
        justify-content: center;
        color: #eee;
    }

    .active::after {
        content: '';
        display: block;
        line-height: 1em;
        border-bottom: 2px solid #27AE60;
        width: 20px;
    }

    .form {
        padding: 0px;
        text-align:center;
    }

    .tabs li {
        display: inline-block;
        padding: 10px 20px;
        font-size: 16px;
        color: #BDBDBD;
        cursor: pointer;
    }

    .form li {
        margin: 10px;
    }

    .btn-submit {
        background: #27AE60!important;
    }

    .git {
        text-align: center;
    }

    .form-input {
        border: none;
        padding: 10px 20px;
        background: #1e292d;
        /*   #28363B; */
        width: 280px;
        outline: none;
        color: #eee
    }
    ul{
        list-style:none;
        
    }
  @media only screen and (max-width: 480px) {
    .wrapper {
      width: 100%;
      margin: 0 auto;
    }
    .prev-img {
      width: 300px;
    }
    .action-buttons {
      text-align: center;
    }
    .hero-wrapper {
      flex-direction: column-reverse;
      height: auto;
      min-height: auto;
      padding-top: 80px;
    }
    .dul,.download{
      flex-direction:column;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue